define(['./QuestionSetFactory'], (QuestionSetFactory)=> {
    const questionSets = {};

    return {
        addQuestionSets: (metaDataObj)=> {
            angular.extend(questionSets, metaDataObj);
        },

        $get: ['TranslateService', (TranslateService)=> {
            return QuestionSetFactory.create(questionSets, TranslateService.instant);
        }]
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/questionsets/QuestionSetService.js